import * as React from "react"

export default function VideoPlayer({ src, poster, ...props }) {

    return <video controls style={{maxWidth: '100%', ...props?.sx}} poster={poster}>
        <source src={src} type="video/mp4" />
    </video>
}